import React, { Component } from 'react';

class SimpleLineIcons extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <div className="card card-default">
          <div className="card-header">
            <i className="fa fa-picture-o"></i> Simple Line Icons
          </div>
          <div className="card-body">
            <div className="row text-center">

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-user icons font-2xl d-block mt-4"></i>icon-user
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-people icons font-2xl d-block mt-4"></i>icon-people
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-user-female icons font-2xl d-block mt-4"></i>icon-user-female
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-user-follow icons font-2xl d-block mt-4"></i>icon-user-follow
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-user-following icons font-2xl d-block mt-4"></i>icon-user-following
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-user-unfollow icons font-2xl d-block mt-4"></i>icon-user-unfollow
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-login icons font-2xl d-block mt-4"></i>icon-login
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-logout icons font-2xl d-block mt-4"></i>icon-logout
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-emotsmile icons font-2xl d-block mt-4"></i>icon-emotsmile
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-phone icons font-2xl d-block mt-4"></i>icon-phone
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-call-end icons font-2xl d-block mt-4"></i>icon-call-end
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-call-in icons font-2xl d-block mt-4"></i>icon-call-in
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-call-out icons font-2xl d-block mt-4"></i>icon-call-out
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-map icons font-2xl d-block mt-4"></i>icon-map
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-location-pin icons font-2xl d-block mt-4"></i>icon-location-pin
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-direction icons font-2xl d-block mt-4"></i>icon-direction
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-directions icons font-2xl d-block mt-4"></i>icon-directions
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-compass icons font-2xl d-block mt-4"></i>icon-compass
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-layers icons font-2xl d-block mt-4"></i>icon-layers
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-menu icons font-2xl d-block mt-4"></i>icon-menu
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-list icons font-2xl d-block mt-4"></i>icon-list
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-options-vertical icons font-2xl d-block mt-4"></i>icon-options-vertical
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-options icons font-2xl d-block mt-4"></i>icon-options
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-down icons font-2xl d-block mt-4"></i>icon-arrow-down
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-left icons font-2xl d-block mt-4"></i>icon-arrow-left
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-right icons font-2xl d-block mt-4"></i>icon-arrow-right
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-up icons font-2xl d-block mt-4"></i>icon-arrow-up
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-up-circle icons font-2xl d-block mt-4"></i>icon-arrow-up-circle
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-left-circle icons font-2xl d-block mt-4"></i>icon-arrow-left-circle
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-right-circle icons font-2xl d-block mt-4"></i>icon-arrow-right-circle
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-arrow-down-circle icons font-2xl d-block mt-4"></i>icon-arrow-down-circle
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-check icons font-2xl d-block mt-4"></i>icon-check
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-clock icons font-2xl d-block mt-4"></i>icon-clock
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-plus icons font-2xl d-block mt-4"></i>icon-plus
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-close icons font-2xl d-block mt-4"></i>icon-close
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-trophy icons font-2xl d-block mt-4"></i>icon-trophy
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-screen-smartphone icons font-2xl d-block mt-4"></i>icon-screen-smartphone
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-screen-desktop icons font-2xl d-block mt-4"></i>icon-screen-desktop
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-plane icons font-2xl d-block mt-4"></i>icon-plane
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-notebook icons font-2xl d-block mt-4"></i>icon-notebook
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-mustache icons font-2xl d-block mt-4"></i>icon-mustache
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-mouse icons font-2xl d-block mt-4"></i>icon-mouse
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-magnet icons font-2xl d-block mt-4"></i>icon-magnet
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-energy icons font-2xl d-block mt-4"></i>icon-energy
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-disc icons font-2xl d-block mt-4"></i>icon-disc
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-cursor icons font-2xl d-block mt-4"></i>icon-cursor
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-cursor-move icons font-2xl d-block mt-4"></i>icon-cursor-move
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-crop icons font-2xl d-block mt-4"></i>icon-crop
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-chemistry icons font-2xl d-block mt-4"></i>icon-chemistry
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-speedometer icons font-2xl d-block mt-4"></i>icon-speedometer
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-shield icons font-2xl d-block mt-4"></i>icon-shield
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-screen-tablet icons font-2xl d-block mt-4"></i>icon-screen-tablet
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-magic-wand icons font-2xl d-block mt-4"></i>icon-magic-wand
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-hourglass icons font-2xl d-block mt-4"></i>icon-hourglass
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-graduation icons font-2xl d-block mt-4"></i>icon-graduation
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-ghost icons font-2xl d-block mt-4"></i>icon-ghost
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-game-controller icons font-2xl d-block mt-4"></i>icon-game-controller
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-fire icons font-2xl d-block mt-4"></i>icon-fire
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-eyeglass icons font-2xl d-block mt-4"></i>icon-eyeglass
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-envelope-open icons font-2xl d-block mt-4"></i>icon-envelope-open
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-envelope-letter icons font-2xl d-block mt-4"></i>icon-envelope-letter
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-bell icons font-2xl d-block mt-4"></i>icon-bell
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-badge icons font-2xl d-block mt-4"></i>icon-badge
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-anchor icons font-2xl d-block mt-4"></i>icon-anchor
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-wallet icons font-2xl d-block mt-4"></i>icon-wallet
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-vector icons font-2xl d-block mt-4"></i>icon-vector
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-speech icons font-2xl d-block mt-4"></i>icon-speech
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-puzzle icons font-2xl d-block mt-4"></i>icon-puzzle
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-printer icons font-2xl d-block mt-4"></i>icon-printer
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-present icons font-2xl d-block mt-4"></i>icon-present
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-playlist icons font-2xl d-block mt-4"></i>icon-playlist
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-pin icons font-2xl d-block mt-4"></i>icon-pin
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-picture icons font-2xl d-block mt-4"></i>icon-picture
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-handbag icons font-2xl d-block mt-4"></i>icon-handbag
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-globe-alt icons font-2xl d-block mt-4"></i>icon-globe-alt
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-globe icons font-2xl d-block mt-4"></i>icon-globe
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-folder-alt icons font-2xl d-block mt-4"></i>icon-folder-alt
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-folder icons font-2xl d-block mt-4"></i>icon-folder
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-film icons font-2xl d-block mt-4"></i>icon-film
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-feed icons font-2xl d-block mt-4"></i>icon-feed
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-drop icons font-2xl d-block mt-4"></i>icon-drop
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-drawer icons font-2xl d-block mt-4"></i>icon-drawer
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-docs icons font-2xl d-block mt-4"></i>icon-docs
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-doc icons font-2xl d-block mt-4"></i>icon-doc
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-diamond icons font-2xl d-block mt-4"></i>icon-diamond
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-cup icons font-2xl d-block mt-4"></i>icon-cup
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-calculator icons font-2xl d-block mt-4"></i>icon-calculator
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-bubbles icons font-2xl d-block mt-4"></i>icon-bubbles
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-briefcase icons font-2xl d-block mt-4"></i>icon-briefcase
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-book-open icons font-2xl d-block mt-4"></i>icon-book-open
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-basket-loaded icons font-2xl d-block mt-4"></i>icon-basket-loaded
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-basket icons font-2xl d-block mt-4"></i>icon-basket
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-bag icons font-2xl d-block mt-4"></i>icon-bag
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-action-undo icons font-2xl d-block mt-4"></i>icon-action-undo
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-action-redo icons font-2xl d-block mt-4"></i>icon-action-redo
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-wrench icons font-2xl d-block mt-4"></i>icon-wrench
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-umbrella icons font-2xl d-block mt-4"></i>icon-umbrella
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-trash icons font-2xl d-block mt-4"></i>icon-trash
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-tag icons font-2xl d-block mt-4"></i>icon-tag
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-support icons font-2xl d-block mt-4"></i>icon-support
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-frame icons font-2xl d-block mt-4"></i>icon-frame
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-size-fullscreen icons font-2xl d-block mt-4"></i>icon-size-fullscreen
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-size-actual icons font-2xl d-block mt-4"></i>icon-size-actual
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-shuffle icons font-2xl d-block mt-4"></i>icon-shuffle
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-share-alt icons font-2xl d-block mt-4"></i>icon-share-alt
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-share icons font-2xl d-block mt-4"></i>icon-share
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-rocket icons font-2xl d-block mt-4"></i>icon-rocket
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-question icons font-2xl d-block mt-4"></i>icon-question
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-pie-chart icons font-2xl d-block mt-4"></i>icon-pie-chart
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-pencil icons font-2xl d-block mt-4"></i>icon-pencil
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-note icons font-2xl d-block mt-4"></i>icon-note
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-loop icons font-2xl d-block mt-4"></i>icon-loop
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-home icons font-2xl d-block mt-4"></i>icon-home
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-grid icons font-2xl d-block mt-4"></i>icon-grid
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-graph icons font-2xl d-block mt-4"></i>icon-graph
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-microphone icons font-2xl d-block mt-4"></i>icon-microphone
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-music-tone-alt icons font-2xl d-block mt-4"></i>icon-music-tone-alt
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-music-tone icons font-2xl d-block mt-4"></i>icon-music-tone
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-earphones-alt icons font-2xl d-block mt-4"></i>icon-earphones-alt
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-earphones icons font-2xl d-block mt-4"></i>icon-earphones
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-equalizer icons font-2xl d-block mt-4"></i>icon-equalizer
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-like icons font-2xl d-block mt-4"></i>icon-like
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-dislike icons font-2xl d-block mt-4"></i>icon-dislike
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-control-start icons font-2xl d-block mt-4"></i>icon-control-start
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-control-rewind icons font-2xl d-block mt-4"></i>icon-control-rewind
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-control-play icons font-2xl d-block mt-4"></i>icon-control-play
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-control-pause icons font-2xl d-block mt-4"></i>icon-control-pause
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-control-forward icons font-2xl d-block mt-4"></i>icon-control-forward
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-control-end icons font-2xl d-block mt-4"></i>icon-control-end
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-volume-1 icons font-2xl d-block mt-4"></i>icon-volume-1
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-volume-2 icons font-2xl d-block mt-4"></i>icon-volume-2
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-volume-off icons font-2xl d-block mt-4"></i>icon-volume-off
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-calendar icons font-2xl d-block mt-4"></i>icon-calendar
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-bulb icons font-2xl d-block mt-4"></i>icon-bulb
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-chart icons font-2xl d-block mt-4"></i>icon-chart
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-ban icons font-2xl d-block mt-4"></i>icon-ban
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-bubble icons font-2xl d-block mt-4"></i>icon-bubble
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-camrecorder icons font-2xl d-block mt-4"></i>icon-camrecorder
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-camera icons font-2xl d-block mt-4"></i>icon-camera
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-cloud-download icons font-2xl d-block mt-4"></i>icon-cloud-download
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-cloud-upload icons font-2xl d-block mt-4"></i>icon-cloud-upload
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-envelope icons font-2xl d-block mt-4"></i>icon-envelope
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-eye icons font-2xl d-block mt-4"></i>icon-eye
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-flag icons font-2xl d-block mt-4"></i>icon-flag
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-heart icons font-2xl d-block mt-4"></i>icon-heart
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-info icons font-2xl d-block mt-4"></i>icon-info
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-key icons font-2xl d-block mt-4"></i>icon-key
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-link icons font-2xl d-block mt-4"></i>icon-link
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-lock icons font-2xl d-block mt-4"></i>icon-lock
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-lock-open icons font-2xl d-block mt-4"></i>icon-lock-open
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-magnifier icons font-2xl d-block mt-4"></i>icon-magnifier
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-magnifier-add icons font-2xl d-block mt-4"></i>icon-magnifier-add
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-magnifier-remove icons font-2xl d-block mt-4"></i>icon-magnifier-remove
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-paper-clip icons font-2xl d-block mt-4"></i>icon-paper-clip
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-paper-plane icons font-2xl d-block mt-4"></i>icon-paper-plane
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-power icons font-2xl d-block mt-4"></i>icon-power
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-refresh icons font-2xl d-block mt-4"></i>icon-refresh
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-reload icons font-2xl d-block mt-4"></i>icon-reload
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-settings icons font-2xl d-block mt-4"></i>icon-settings
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-star icons font-2xl d-block mt-4"></i>icon-star
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-symbol-female icons font-2xl d-block mt-4"></i>icon-symbol-female
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-symbol-male icons font-2xl d-block mt-4"></i>icon-symbol-male
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-target icons font-2xl d-block mt-4"></i>icon-target
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-credit-card icons font-2xl d-block mt-4"></i>icon-credit-card
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-paypal icons font-2xl d-block mt-4"></i>icon-paypal
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-tumblr icons font-2xl d-block mt-4"></i>icon-social-tumblr
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-twitter icons font-2xl d-block mt-4"></i>icon-social-twitter
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-facebook icons font-2xl d-block mt-4"></i>icon-social-facebook
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-instagram icons font-2xl d-block mt-4"></i>icon-social-instagram
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-linkedin icons font-2xl d-block mt-4"></i>icon-social-linkedin
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-pinterest icons font-2xl d-block mt-4"></i>icon-social-pinterest
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-github icons font-2xl d-block mt-4"></i>icon-social-github
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-gplus icons font-2xl d-block mt-4"></i>icon-social-gplus
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-reddit icons font-2xl d-block mt-4"></i>icon-social-reddit
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-skype icons font-2xl d-block mt-4"></i>icon-social-skype
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-dribbble icons font-2xl d-block mt-4"></i>icon-social-dribbble
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-behance icons font-2xl d-block mt-4"></i>icon-social-behance
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-foursqare icons font-2xl d-block mt-4"></i>icon-social-foursqare
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-soundcloud icons font-2xl d-block mt-4"></i>icon-social-soundcloud
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-spotify icons font-2xl d-block mt-4"></i>icon-social-spotify
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-stumbleupon icons font-2xl d-block mt-4"></i>icon-social-stumbleupon
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-youtube icons font-2xl d-block mt-4"></i>icon-social-youtube
              </div>

              <div className="col-6 col-sm-4 col-md-3">
                <i className="icon-social-dropbox icons font-2xl d-block mt-4"></i>icon-social-dropbox
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SimpleLineIcons;
